import React, {useEffect, useState} from "react";

import "./NavigationBar.css";

import {Button, Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Link, useHistory, withRouter} from "react-router-dom";
import Loader from "../../components/Loader";
import {
    getUser,
    hasFiltersAdd, hasFormatsFullAccess,
    hasGoToProdRead,
    hasManagementRead, hasPermission,
    hasTSAddition,
    hasWashingMachineRead
} from "../../helpers/jwt";
import config from "../menu/MenuConfig";
import IconButton from "../../components/button/IconButton";
import Tooltip from "../../components/tooltip/Tooltip";
import PrintButton from "../../components/PrintButton";
import { useTranslation } from 'react-i18next';
import QRScannerModal from "../../components/QRScannerModal";
import PartInfoModal from "../../components/PartInfoModal";


const logoImage = "/assets/img/blister_logo.png";
const navigationBarTitleValue = <> <span className="d-none d-lg-inline mr-2 text-gray-600 small">{getUser()}</span><i
    className="far fa-user-circle" style={{fontSize: "22px"}}/> </>;


const NavigationBar = (props) => {

    const { t } = useTranslation();
    const history = useHistory();
    const [showQRScanner, setShowQRScanner] = useState(false);
    const [showPartInfo, setShowPartInfo] = useState(false);

    function handleLogout() {
        setLoader(true);
        localStorage.removeItem("user_jwt");
        props.history.push("/login");
    }

    const toggleJsUrl = "/assets/js/toggle.js";


    const initToggleScript = () => {
        const script = document.createElement("script");

        script.src = toggleJsUrl;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    };


    // loader
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        initToggleScript();
    }, []);

    const handleQRScan = (result) => {
        // In a real application, you would process the QR code result here
        // For now, we'll just show the part info modal
        setShowPartInfo(true);
    };

    return (
        <>
            <Loader loader={loader} setLoader={setLoader}/>
            <Navbar variant="light" fixed="top" bg="light" expand className="Navigation__wrapper  mb-4 topbar">
                <Container fluid>

                    <Navbar as="ul" className="navbar-nav center-nav">

                        <Nav>
                            <Nav.Item id={"sidebarToggle"}>
                                <Nav.Link active> <i className="fas fa-bars"></i>
                                </Nav.Link>
                            </Nav.Item>

                            {hasFormatsFullAccess() &&
                                <Nav.Item>
                                    <Nav.Link active onClick={() => history.push("/format")}>{t("common.add_new_format")}</Nav.Link>
                                </Nav.Item>
                            }
                        </Nav>
                    </Navbar>

                    <Navbar as="ul" className="nav navbar-nav flex-nowrap ml-auto">
                        <PrintButton contentRef={props.printRef}/>

                        <Nav.Item>
                            <Button
                                variant="light"
                                onClick={() => setShowQRScanner(true)}
                                className="mr-2"
                            >
                                <i className="fas fa-qrcode"></i>
                            </Button>
                        </Nav.Item>

                        <div className="d-sm-block topbar-divider"></div>
                        <Nav as="li" className="nav-item dropdown no-arrow" role="presentation">
                            <NavDropdown className="no-arrow" title={navigationBarTitleValue}>

                                <NavDropdown.Item role="presentation" onClick={handleLogout}>
                                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"/>&nbsp;{t("forms.logout")}
                                </NavDropdown.Item>

                            </NavDropdown>
                        </Nav>
                    </Navbar>
                </Container>
            </Navbar>

            <QRScannerModal
                show={showQRScanner}
                onHide={() => setShowQRScanner(false)}
                onScan={handleQRScan}
            />

            <PartInfoModal
                show={showPartInfo}
                onHide={() => setShowPartInfo(false)}
            />
        </>
    );
};

export default withRouter(NavigationBar);